import { render, staticRenderFns } from "./RequAdd.vue?vue&type=template&id=53143270&scoped=true&"
import script from "./RequAdd.vue?vue&type=script&lang=js&"
export * from "./RequAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53143270",
  null
  
)

export default component.exports